import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchEnrolledCourses } from "../../redux/Actions/enrolledStudentCoursesActions";

const BookingConfirmationModal = ({
  open,
  onClose,
  status,
  courseTitle,
  teacherName,
}) => {
  const { t } = useTranslation("ui");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSuccess = status === "success";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "90%", sm: "70%", md: "50%" },
          borderRadius: 3,
          textAlign: "center",
          p: { xs: 2, sm: 3 },
        },
      }}
    >
      <Box sx={{ position: "absolute", right: 8, top: 8 }}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogTitle sx={{ pt: 4 }}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          {isSuccess ? (
            <CheckCircleOutlineIcon
              sx={{ fontSize: { xs: 80, sm: 120 }, color: "success.main" }}
            />
          ) : (
            <HighlightOffIcon
              sx={{ fontSize: { xs: 80, sm: 120 }, color: "error.main" }}
            />
          )}
        </Box>
        <Typography
          variant="h5"
          fontWeight="bold"
          gutterBottom
          sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
        >
          {isSuccess
            ? t("bookingConfirmation.successTitle")
            : t("bookingConfirmation.failureTitle")}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "1rem", sm: "1.3rem" },
            mb: 4,
            lineHeight: 1.6,
          }}
        >
          {isSuccess
            ? t("bookingConfirmation.successMessage", {
                teacherName,
                courseTitle,
              })
            : t("bookingConfirmation.failureMessage")}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            justifyContent: "center",
            mt: 2,
          }}
        >
          {isSuccess && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch(fetchEnrolledCourses());
                navigate("/dashboard");
              }}
              sx={{ minWidth: 160, fontSize: "1rem", py: 1 }}
            >
              {t("bookingConfirmation.goToDashboard")}
            </Button>
          )}
          <Button
            variant={isSuccess ? "outlined" : "contained"}
            color={isSuccess ? "primary" : "error"}
            onClick={onClose}
            sx={{ minWidth: 120, fontSize: "1rem", py: 1 }}
          >
            {t("bookingConfirmation.close")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BookingConfirmationModal;
